import {
  ChevStateWrap,
  TravellerCountWigetStyle,
} from "./TravellingToWidget.style";

import { FlexComp, SpanTag } from "@tm/static";
import { BlueChev } from "@tm/static/icons";
import { theme } from "@tm/utility/global";
import FormattedText, { TextNodeType } from "../FormattedText/FormattedText";

interface TravellerCountWigetProps {
  countValue?: number;
  showSelectSection?: boolean;
  travCountTitle?: TextNodeType | string;
  travSelectTitle?: TextNodeType | string;
  travCountInfo?: TextNodeType | string;
  postSelectDesc?: TextNodeType | string;
  description?: TextNodeType | string;
  postSelectTitle?: TextNodeType | string;
  handleCaptureCountDecr?: () => void;
  isAgeRangeSelected?: boolean;
  travAgeRange?: any[];
  handleSelectSection: () => void;
}

const TravellerCounterWigetV2 = ({
  countValue,
  travSelectTitle,
  postSelectTitle,
  postSelectDesc,
  travCountTitle,
  isAgeRangeSelected,
  showSelectSection,
  handleSelectSection,
  description,
  travAgeRange,
}: TravellerCountWigetProps) => {
  const getAgeRanges = (travAgeRange: any[]) => {
    let ageRanges = travAgeRange.map((ageRange: any) => {
      return ageRange?.label?.text?.value;
    });
    var ageRangesStr = ageRanges.join(", ");
    if (ageRangesStr.length > 25) {
      return ageRangesStr.substring(0, 25) + "...";
    } else {
      return ageRangesStr;
    }
  };
  return (
    <TravellerCountWigetStyle onClick={handleSelectSection}>
      <FlexComp flexDirection="column">
        <FlexComp gap="8px">
          <SpanTag
            textTransform="uppercase"
            color={showSelectSection ? theme.blueText : theme.greyText}
            fontWeight={"bold"}
            fontSize="xs"
          >
            {travCountTitle && <FormattedText value={travCountTitle} />}
          </SpanTag>
          <ChevStateWrap open={showSelectSection}>
            <BlueChev />
          </ChevStateWrap>
        </FlexComp>
        {isAgeRangeSelected ? (
          <FlexComp flexDirection="column" gap="0px">
            <SpanTag fontWeight="black" fontSize="md">
              {countValue}{" "}
              {postSelectTitle && <FormattedText value={postSelectTitle} />}
            </SpanTag>
            <SpanTag color={theme.greyText6} fontSize="xs">
              {postSelectDesc && <FormattedText value={postSelectDesc} />}{" "}
              {getAgeRanges(travAgeRange ?? [])}
            </SpanTag>
          </FlexComp>
        ) : (
          <FlexComp flexDirection="column" gap="0px">
            <SpanTag fontWeight="black" fontSize="md">
              {travSelectTitle && <FormattedText value={travSelectTitle} />}
            </SpanTag>
            <SpanTag color={theme.greyText6} fontSize="xs">
              {description && <FormattedText value={description} />}
            </SpanTag>
          </FlexComp>
        )}
      </FlexComp>
    </TravellerCountWigetStyle>
  );
};

export default TravellerCounterWigetV2;
